module.exports = __webpack_public_path__ + "img/reset_button.a2266581.png";